import { createFileRoute, useParams } from "@tanstack/react-router";
import { createAssetAttachmentsListQueryOptions } from "@/features/attachments/adapters/asset-attachments-adapter";
import { AssetAttachmentsWorkspace } from "@/features/attachments/components/asset-attachments-workspace";
import { ATTACHMENTS_FILES_PAGE_SIZE } from "@/features/attachments/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets/$assetId/workspace/attachments",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createAssetAttachmentsListQueryOptions({
				assetId: params.assetId,
				organizationId: params.orgId,
				start: 1,
				count: ATTACHMENTS_FILES_PAGE_SIZE,
			}),
		),
	component: AssetWorkspaceAttachmentsTab,
});

/**
 * Record-hosted Asset workspace Attachments tab — thin route adapter.
 */
function AssetWorkspaceAttachmentsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets/$assetId/workspace/attachments",
	});

	return (
		<AssetAttachmentsWorkspace orgId={params.orgId} assetId={params.assetId} />
	);
}
